import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { getCurrentUser } from 'aws-amplify/auth';

/**
 * Service for checking authentication status.
 * Separated for testability.
 */
export class AuthService {
  async isAuthenticated(): Promise<boolean> {
    try {
      await getCurrentUser();
      return true;
    } catch {
      return false;
    }
  }
}

/**
 * Authentication guard that protects routes requiring user authentication.
 * Redirects unauthenticated users to the login page.
 */
export const authGuard = async () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const isAuthenticated = await authService.isAuthenticated();

  if (isAuthenticated) {
    return true;
  }

  return router.parseUrl('/login');
};
